/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SeriesDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function SeriesDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/NewImageSeriesAction/Content/SeriesDate",
  onChange,
  isInvalid
  
}) {
let imageSerieFormDateValueData = fromData.useDataFormat({ viewPath,
context: 'image_serie_form',
path: 'date',
format: fromFormat.dateShortIn,
})
let imageSerieFormDateIsValidData = fromData.useDataIsValid({ viewPath,
context: 'image_serie_form',
path: 'date',
validate: fromValidate.date,
required: true,
})
let imageSerieFormDateChangeData = fromData.useDataChange({ viewPath,
context: 'image_serie_form',
path: 'date',
formatOut: fromFormat.dateShortOutTempFixForMaskedInput,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="date"
 marginRight={dtSpaceXs}
 data="image_serie_form.date"
 format="/Data/format.js dateShortIn"
 formatOut="/Data/format.js dateShortOutTempFixForMaskedInput"
 required={true}
 onChange={imageSerieFormDateChangeData}
 value={imageSerieFormDateValueData}
 validate="/Data/validate.js date"
 invalid={!imageSerieFormDateIsValidData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Series date"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}